import { useEffect } from 'react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps): JSX.Element => {
  useEffect(() => {
    console.error('Error caught by boundary:', {
      message: error.message,
      stack: error.stack,
      name: error.name,
    });
  }, [error]);

  return (
    <div role="alert" className="flex flex-col items-center justify-center h-screen p-4">
      <h2 className="text-lg font-semibold text-red-600 mb-2">Something went wrong:</h2>
      <pre className="text-red-500 bg-muted p-4 rounded-md mb-4 whitespace-pre-wrap">
        {error.message}
      </pre>
      <button
        onClick={resetErrorBoundary}
        className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
      >
        Try again
      </button>
    </div>
  );
};
